export default {
  ADS: {
    client: 'ca-pub-5442972248172818',
    slotInFeed: '2105028631',
    slotInArticle: '7974047383',
    layout: '-fg+5n+6t-e7+r'
  }
}



// WEBPACK FOOTER //
// ./src/constant/index.js